import RankingScopeContext from "../enums/RankingScopeContext.js";

/**
 * Based on https://flightscope.atlassian.net/browse/BBP-482?focusedCommentId=45029
 */
class RankingScope {
    constructor(context, sessionId, teamId, opponentTeamId, tagId, handedness, opponentId, opponentHandedness, pitchType) {
        if (!context || typeof(context) !== 'string') {
            throw new TypeError('context must be an non empty string');
        }
        if (!Object.values(RankingScopeContext).find(s => s && s.key === context)) {
            throw new Error(`unknown type of context, cannot find key ${context} in RankingScopeContext Enum`);
        }
        this.context = context;

        if (typeof(sessionId) === 'undefined') {
            this.sessionId = null;
        }
        else if (!Number.isInteger(sessionId) || sessionId < 1) {
            throw new TypeError('sessionId must be an integer greater than 0');
        }
        else {
            this.sessionId = sessionId;
        }

        if (typeof(teamId) === 'undefined') {
            this.teamId = null;
        }
        else if (!Number.isInteger(teamId) || teamId < 1) {
            throw new TypeError('teamId must be an integer greater than 0');
        }
        else {
            this.teamId = teamId;
        }

        if (typeof(opponentTeamId) === 'undefined') {
            this.opponentTeamId = null;
        }
        else if (!Number.isInteger(opponentTeamId) || opponentTeamId < 1) {
            throw new TypeError('opponentTeamId must be an integer greater than 0');
        }
        else {
            this.opponentTeamId = opponentTeamId;
        }

        if (typeof(tagId) === 'undefined') {
            this.tagId = null;
        }
        else if (!Number.isInteger(tagId) || tagId < 1) {
            throw new TypeError('tagId must be an integer greater than 0');
        }
        else {
            this.tagId = tagId;
        }

        if (typeof(opponentId) === 'undefined') {
            this.opponentId = null;
        }
        else if (!Number.isInteger(opponentId) || opponentId < 1) {
            throw new TypeError('opponentId must be an integer greater than 0');
        }
        else {
            this.opponentId = opponentId;
        }

        if (typeof(handedness) === 'undefined') {
            this.handedness = null;
        }
        else if (!handedness) {
            throw new TypeError('handedness cannot be empty');
        }
        else {
            this.handedness = handedness;
        }

        if (typeof(opponentHandedness) === 'undefined') {
            this.opponentHandedness = null;
        }
        else if (!opponentHandedness) {
            throw new TypeError('opponentHandedness cannot be empty');
        }
        else {
            this.opponentHandedness = opponentHandedness;
        }

        if (typeof(pitchType) === 'undefined') {
            this.pitchType = null;
        }
        else if (!pitchType) {
            throw new TypeError('pitchType cannot be empty');
        }
        else {
            this.pitchType = pitchType;
        }
    }

    toString() {
        return '['+[this.context, this.sessionId, this.teamId, this.opponentTeamId, this.tagId, this.handedness, this.opponentId, this.opponentHandedness, this.pitchType].join(',') + ']'
    }

    static forGeneralContext(sessionId, teamId, opponentTeamId, tagId, handedness, opponentId, opponentHandedness, pitchType) {
        return new RankingScope(
            RankingScopeContext.General.key,
            sessionId, teamId, opponentTeamId, tagId, handedness, opponentId, opponentHandedness, pitchType
        );
    }

    static forPitchingContext(sessionId, pitcherTeamId, batterTeamId, pitcherId, throws, batterId, bats, pitchType) {
        return new RankingScope(
            RankingScopeContext.Pitching.key,
            sessionId, pitcherTeamId, batterTeamId, pitcherId, throws, batterId, bats, pitchType
        );
    }

    static forBattingContext(sessionId, pitcherTeamId, batterTeamId, pitcherId, throws, batterId, bats, pitchType) {
        return new RankingScope(
            RankingScopeContext.Batting.key,
            sessionId, batterTeamId, pitcherTeamId, batterId, bats, pitcherId, throws, pitchType
        );
    }

    // TODO - add more...
}

export default RankingScope;